<template>
  <div class="sidebar-container" :class="[isCollapse ? 'isCollapse' : '']">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        background-color="#304156"
        text-color="#BFCBD9"
        :collapse-transition="false"
        :unique-opened="true"
        :router="true"
        :default-active="activeMenu"
        :collapse="isCollapse"
      >
        <SidebarItem
          v-for="(route, index) in routes"
          :key="route.name || route.path || index"
          :item="route"
          :basePath="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>
<script>
import SidebarItem from "./siderbarItem";
import { mapState } from "vuex";
export default {
  components: {
    SidebarItem,
  },
  computed: {
    ...mapState("layout", ["isCollapse"]),
    ...mapState("permission", {
      permissionRoutes: state => state.routes,
    }),
    activeMenu() {
      return this.$route.path;
    },
    routes() {
      return this.filterRoutes(this.permissionRoutes);
    },
  },
  methods: {
    filterRoutes(routes) {
      if (!(routes && routes.length)) return [];

      return routes
        .filter(item => item && !item.hidden)
        .map(item => ({
          ...item,
          ...(item.children
            ? { children: this.filterRoutes(item.children) }
            : {}),
        }));
    },
  },
};
</script>

<style lang="less">
.scrollbar-wrapper {
  overflow-x: hidden !important;
}
.el-scrollbar__bar.is-vertical {
  right: 0px;
}
.el-scrollbar {
  height: 100%;
}
</style>

<style lang="less" scoped>
.sidebar-container {
  z-index: 1001;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 260px;
  height: 100%;
  background-color: #304156;
  transition: all 0.28s ease;
  .el-menu {
    border: none;
  }
  &.isCollapse {
    width: 64px !important;
  }
}
</style>
